<template>
  <q-page class="column no-wrap bg-white">
    <!-- The toolbar was moved into DemoPitch to handle the Edit Context dynamically -->
    <GameSelection class="col-grow" />
  </q-page>
</template>

<script setup lang="ts">
import GameSelection from 'components/GameSelection.vue'

// Notice: Zero state or logic needed here anymore!
// The component handles its own data and will route itself if 'Hit' is selected.
</script>
